import { ShieldCheck, Sparkles } from 'lucide-react';

export default function Privacy() {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-wrapper" style={{ paddingBottom: '4rem' }}>
        <div className="grid-2">
          <div>
            <span className="section-label">
              <Sparkles size={14} style={{ marginRight: '0.4rem', verticalAlign: 'middle' }} />
              Privacy Policy
            </span>
            <h1 className="hero-gradient-text" style={{ fontSize: '3rem' }}>
              How Roriri collects, uses, and protects information
            </h1>
            <p className="section-desc" style={{ fontSize: '1.2rem', marginBottom: '2.5rem' }}>
              We are committed to protecting your data and explaining how it is handled.
            </p>
          </div>

          <div className="hero-mockup-wrapper" style={{ padding: '2rem' }}>
            <div className="premium-card" style={{ padding: '2rem', display: 'flex', gap: '1.5rem', alignItems: 'center', margin: 0 }}>
              <div className="icon-box" style={{ margin: 0, flexShrink: 0 }}>
                <ShieldCheck size={32} />
              </div>
              <div>
                <h3 style={{ fontSize: '1.2rem', marginBottom: '0.25rem' }}>Secure & Private</h3>
                <p style={{ margin: 0, fontSize: '0.95rem' }}>Your personal and institutional privacy is integrated into every layer of our platform.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Privacy Content Section */}
      <section style={{ borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)', background: 'rgba(241, 245, 249, 0.2)' }}>
        <div className="section-wrapper">
          <div className="legal-container">
            <div className="legal-body-card">
              <h2>1. Introduction</h2>
              <p>At Roriri, we take your privacy seriously. This policy explains how we collect, use, disclose, and safeguard your information when you use our school management platform.</p>

              <h2>2. Information We Collect</h2>
              <p>We collect personal, school, and technical information to provide and improve our service.</p>
              <p><strong>Personal Information:</strong> Name, email, phone number, school affiliation, and student or parent details.</p>
              <p><strong>Technical Information:</strong> IP address, browser type, device information, usage patterns, and cookies.</p>

              <h2>3. How We Use Your Information</h2>
              <p>We use data to operate the service, provide support, send updates, improve the platform, and monitor usage for technical issues.</p>

              <h2>4. Data Security</h2>
              <p>We implement security measures including 256-bit SSL encryption, encrypted storage, access controls, and regular backups.</p>

              <h2>5. Data Sharing</h2>
              <p>We do not sell or rent your personal information. Trusted service providers may process data on our behalf under confidentiality agreements.</p>

              <h2>6. Your Rights</h2>
              <p>You may request access, correction, deletion, portability, or restriction of your personal data, and withdraw consent at any time.</p>

              <h2>7. Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy, contact us at{' '}
                <a href="mailto:admin@roririsoft.com">admin@roririsoft.com</a>.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
